import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import login from '@tencent/vft-common/login'; // 对login库做一些包装

export function init() {
  return new Promise(function (resolve) {
    login.init(function () {
      console.log('init');
      resolve(true);
    });
    setTimeout(function () {
      console.log('timeout');
      resolve(false);
    }, 5000);
  });
}
export function isLogin() {
  return login.isLogin();
} // eslint-disable-next-line no-underscore-dangle

function _isStrictLogin() {
  return new Promise(function (resolve) {
    login.isStrictLogin(function (result) {
      console.log('strictLogin', result);
      resolve(result);
    });
    var result = isLogin();
    setTimeout(function () {
      resolve(result);
    }, 3000);
  });
}

export function checkLogin() {
  return _checkLogin.apply(this, arguments);
}

function _checkLogin() {
  _checkLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _isStrictLogin();

          case 2:
            if (!_context.sent) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", true);

          case 4:
            if (isLogin()) {
              // 如果有弱登录态、清掉
              login.logout();
            }

            return _context.abrupt("return", false);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkLogin.apply(this, arguments);
}